import React, { useState, useEffect } from 'react';
import Sidebar from '../Sidebar/Sidebar';
import CustomContent from '../CustomContent/CustomContent';
import './CustomLayout.css';
import PropTypes from 'prop-types';
import {Link} from "react-router-dom";
import SecondaryNavbar from 'components/secondaryNavbar/SecondaryNavbar';
import { useSelector, connect } from "react-redux";
import { Layout, Icon, Button, Row, Col } from 'antd';
import { getLoy3ProfileData, getLoy3AuthToken } from 'selectors/authentication';
import { getMembershipInfo } from 'actions/sandos4UAction';

const { Content } = Layout;

const AppContentComponent = ({ 
  onBack, 
  header, 
  children, 
  loy3ProfileData, 
  loy3AuthToken, 
  hideLayoutElements = false,
  hideAssistance = false,
  userData,
  registrationInfo
}, context) => {
  const [showSidebar, setShowSidebar] = useState(false);
  const [membershipData, setMembershipData] = useState(null);
  const member = useSelector((state) => state.authentication.loy3Profile);
  useEffect(() => {
    const handleToggleSidebar = () => setShowSidebar(prev => !prev);

    document.addEventListener('toggleSidebar', handleToggleSidebar);

    return () => {
      document.removeEventListener('toggleSidebar', handleToggleSidebar);
    };
  }, []);

  useEffect(() => {
    if (!loy3AuthToken) return;
    const locale = "en";
    const brandId = 1;
    getMembershipInfo(loy3AuthToken, locale, brandId);
  }, [getMembershipInfo, loy3AuthToken]);


  useEffect(() => {
    const storedData = localStorage.getItem('_loy3MembershipInfo');
    if (storedData) {
      try {
        setMembershipData(JSON.parse(storedData));
      } catch (e) {
        console.error("Error parsing membership data from storage:", e);
      }
    }
  }, [loy3AuthToken]);

  return (
    <div className="layout-container">    
      {!hideLayoutElements && !window.location.pathname.includes('/forgot-password') && !window.location.pathname.includes('/create-password') && (
        <div className={`sidebar-container ${showSidebar ? 'active' : ''}`}>
          <Sidebar 
            member={member} 
            loy3ProfileData={loy3ProfileData} 
            membershipData={membershipData} 
            loy3AuthToken={loy3AuthToken} 
            userData={userData}
            registrationInfo={registrationInfo}
          />
        </div>
      )}

      <div className={`content-container ${hideLayoutElements ? 'content-container--public' : ''}`}>
        <Content style={{
          paddingLeft: hideLayoutElements ? "0px" : "30px",
          paddingRight: hideLayoutElements ? "0px" : "10px",
          paddingTop: hideLayoutElements ? "0px" : "0px",
          flex: "1"
        }}
        className="content">
          {!hideLayoutElements && !window.location.pathname.includes('/forgot-password') && !window.location.pathname.includes('/create-password') && (
            <Row type="flex">
              <Col lg={21} xs={24}>
                <SecondaryNavbar />
              </Col>
            </Row>
          )}

          {header &&
            <Row type="flex" justify="center" className="h-md pb-8">
              <Col span={24} className="header-content">
                {onBack &&
                  <Button onClick={onBack} type="link" className="btn-back"><Icon type="arrow-left" /> {context.t("Back")}</Button>
                }
                <h1 className="header-title">{header} </h1>
              </Col>
            </Row>
          }

          <Row gutter={48} type="flex" justify="center">
            <Col style={{ paddingLeft: '0px', paddingRight: '0px' }} lg={hideLayoutElements ? 24 : 21} xs={24}>
              <div className={`content-inner-wrapper ${hideLayoutElements ? 'content-inner-wrapper--public' : ''}`}>
                {children}
              </div>
            </Col>
          </Row>

          {!hideAssistance && (
            <Row gutter={24}>
              <Col span={24} className="pb-12" style={{ paddingLeft: '12px', paddingRight: '50px', textAlign: 'right', marginTop: '20px'}}>
                {context.t('Do you need assistance?')}
                <br/>
                <br/>
                <a style={{marginLeft: "0px", textDecoration: "none"}} href="mailto:sandos4u.mx@sandos.com" className="font-semibold txt-orange underline ml-1">{context.t('Contact us')}</a>
              </Col>
            </Row>
          )}
    
        </Content>
      </div>
    </div>
  );
};

/*const AppContentComponent = ({ onBack, header, children }, context) => (
  <Content className="content">

    {header &&
      <Row type="flex" justify="center" className="h-md pb-8">
        <Col span={24} className="header-content">
          {onBack &&
            <Button onClick={onBack} type="link" className="btn-back"><Icon type="arrow-left" /> {context.t("Back")}</Button>
          }
          <h1 className="header-title">{header} </h1>
        </Col>
      </Row>
    }
    <Row gutter={48} type="flex" justify="center">
      <Col lg={21} xs={24}>
        {children}
      </Col>
    </Row>

  </Content>
)*/

AppContentComponent.propTypes = {
  onBack: PropTypes.func,
  header: PropTypes.string,
  children: PropTypes.node.isRequired,
  getMembershipInfo: PropTypes.func.isRequired,
  hideLayoutElements: PropTypes.bool,
  hideAssistance: PropTypes.bool,
}

AppContentComponent.contextTypes = {
  t: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  loy3ProfileData: getLoy3ProfileData(state),
  loy3AuthToken: getLoy3AuthToken(state),
});


const mapDispatchToProps = (dispatch) => ({
  getMembershipInfo: (authToken, locale, brandId) => dispatch(getMembershipInfo(authToken, locale, brandId))
});

export default connect(mapStateToProps, mapDispatchToProps)(AppContentComponent);
